import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../../layouts/DashboardLayout";
import api from "../../../api";
import { Eye, EyeOff, GraduationCap } from "lucide-react";

export default function StudentNew() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    class_name: "",
    password: "",
    phone_number: "",
    is_active: true,
  });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.createStudent(formData);
      alert("Student created successfully!");
      navigate("/student");
    } catch (err) {
      alert("Failed to create student: " + err.message);
    }
  };

  return (
    <DashboardLayout>
      {/* Back Button */}
      <div className="mb-4 max-w-xl mx-auto">
        <button
          type="button"
          onClick={() => navigate("/student")}
          className="inline-flex items-center gap-2 text-gray-500 hover:text-gray-800 transition-colors"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span className="font-medium">Back to Students</span>
        </button>
      </div>
      <div className="max-w-xl mx-auto bg-white rounded-2xl border border-secondary-100 shadow-sm overflow-hidden">
        <div className="px-6 py-5 border-b border-secondary-100 flex items-center gap-3">
          <div className="w-9 h-9 bg-primary-100 rounded-xl flex items-center justify-center">
            <GraduationCap className="w-5 h-5 text-primary-600" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-secondary-900">Add New Student</h2>
            <p className="text-xs text-secondary-400">Fields marked <span className="text-red-500">*</span> are required</p>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-3">
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            className="border p-2 rounded w-full"
            required
          />
          <input
            type="number"
            name="phone_number"
            placeholder="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            className="border p-2 rounded w-full"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="border p-2 rounded w-full"
            required
          />
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="border p-2 rounded w-full pr-10"
              required
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>
          <input
            type="text"
            name="class_name"
            placeholder="Class"
            value={formData.class_name}
            onChange={handleChange}
            className="border p-2 rounded w-full"
            required
          />
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
            />
            Active
          </label>

          <div className="flex justify-end gap-2">
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
}
